// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__37m55","range":"MonthRangeSwitch_range__2eAWv","disabled":"MonthRangeSwitch_disabled__1c_kv"};